import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  Wrapper,
  SelectWrapper,
  Select,
  Text,
  Icon,
  Envelop,
  EnvelopItem,
  SelectedItemsWrapper,
  SelectedItem,
  SelectedItemCloseIcon,
} from './MultiSelectionDropdownMenu.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MultiSelectionDropdownMenu = ({
  dropdownMenuItemsList,
  dropdownMenuSelectedArr,
  dropdownMenuPlaceholder,
  disabled,
  handleDropdownMenuChange,
}) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dropdownMenuWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isMenuEnvelopOpen, setIsMenuEnvelopOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        dropdownMenuWrapperRef.current &&
        dropdownMenuWrapperRef.current.contains(event.target) === false
      )
        setIsMenuEnvelopOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [dropdownMenuWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleMenuSelectClick = () => {
    if (disabled) return;

    setIsMenuEnvelopOpen(prevState => !prevState);
  };

  const handleDropdownMenuItemClick = selectedObj => {
    setIsMenuEnvelopOpen(false);

    if (
      dropdownMenuSelectedArr.some(selectedItem => selectedItem.key === selectedObj.key) === false
    ) {
      const updateSelectedItems = [...dropdownMenuSelectedArr, selectedObj];
      handleDropdownMenuChange(updateSelectedItems);
    }
  };

  const handleSelectedItemItemDeleteIconClick = selectedItem => {
    const updateSelectedItems = dropdownMenuSelectedArr.filter(
      result => result.key !== selectedItem.key,
    );

    handleDropdownMenuChange(updateSelectedItems);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      <SelectWrapper ref={dropdownMenuWrapperRef}>
        <Select
          data-testid="dropdown-menu-select"
          disabled={disabled}
          onClick={handleMenuSelectClick}
        >
          <Text data-testid="dropdown-menu-text">{dropdownMenuPlaceholder}</Text>
          <Icon data-testid="dropdown-menu-icon" />
        </Select>
        {isMenuEnvelopOpen && (
          <Envelop data-testid="dropdown-menu-envelope">
            {dropdownMenuItemsList.map(menuItem => (
              <EnvelopItem
                data-testid={menuItem.key}
                key={menuItem.key}
                onClick={() =>
                  handleDropdownMenuItemClick({
                    key: menuItem.key,
                    name: menuItem.name,
                  })
                }
              >
                {menuItem.name}
              </EnvelopItem>
            ))}
          </Envelop>
        )}
      </SelectWrapper>
      <SectionDivider gap={4} />
      <SelectedItemsWrapper>
        {dropdownMenuSelectedArr.map(selectedItem => (
          <SelectedItem key={selectedItem.key}>
            {selectedItem.name}
            <SelectedItemCloseIcon
              onClick={() => handleSelectedItemItemDeleteIconClick(selectedItem)}
            />
          </SelectedItem>
        ))}
      </SelectedItemsWrapper>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MultiSelectionDropdownMenu.propTypes = {
  dropdownMenuItemsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dropdownMenuSelectedArr: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  dropdownMenuPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
  handleDropdownMenuChange: PropTypes.func.isRequired,
};

MultiSelectionDropdownMenu.defaultProps = {
  dropdownMenuPlaceholder: '',
  disabled: false,
};

export default MultiSelectionDropdownMenu;
